import { useSearchParams } from 'react-router-dom'
import { PaymentSDKContainer } from '@/components/payment-sdk/payment-sdk-container'
import { ErrorDisplay } from '@/components/error-display'
import { ApiError } from '@/lib/api/types'

export function SDKRenderPage() {
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('sessionId')
  const email = searchParams.get('email')
  const payloadParam = searchParams.get('payload')

  // Parse payload if provided
  let payload: any = null
  if (payloadParam) {
    try {
      payload = JSON.parse(decodeURIComponent(payloadParam))
    } catch (err) {
      console.error('Failed to parse payload:', err)
    }
  }

  if (!sessionId) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50">
        <div className="w-full max-w-md p-4">
          <ErrorDisplay
            error={
              {
                status: 400,
                message: 'Session ID is required. Please check the URL.',
                code: 'MISSING_SESSION_ID',
              } as ApiError
            }
          />
        </div>
      </div>
    )
  }

  // Log the email and payload for debugging (they are available via URL params)
  if (email) {
    console.log('Email from URL:', email)
  }
  if (payload) {
    console.log('Payload from URL:', payload)
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full ">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment Form</h1>
            {email && (
              <p className="text-sm text-gray-600">
                Customer Email: <span className="font-medium">{email}</span>
              </p>
            )}
          </div>
          <PaymentSDKContainer sessionId={sessionId} environment="sandbox" />
          {/* Payment container - must exist in DOM before SDK initializes */}
          <div id="payment-container" style={{ display: 'none', minHeight: '500px' }} />
        </div>
      </div>
    </div>
  )
}
